import request from '@/utils/request';

export async function productApi(pageNo, pageSize) {
  const response = await request.get('/f/project-list/'+1, {
    params: { pageNo, pageSize}
  });
  return response;
}
